import TenantBar from './TenantBar.jsx'
import MenuButton from './MenuButton.jsx'
import UserBar from './UserBar.jsx'
import NotificationBar from './NotificationBar.jsx'
import LogoEchoSystem from '../ui/LogoEchoSystem.jsx'

const HeaderNavBar = ({openMenu,setOpenMenu,companiesList,branchesList,tenantUsername,tenantImage,tenant,companySelected,branchSelected}) => {
    
    return (
        <>
            {/* <div className='primary-bg-color  sticky top-0 z-50   '>
            <NotificationBar />
            <div className="px-3  m-auto  w-full p-1">
                <div className='flex flex-col md:flex-row  w-full py-1 justify-between items-center '>
                    <div className='flex items-center justify-between w-full '>
                        <MenuButton openMenu = {openMenu}  setOpenMenu = {setOpenMenu} />
                        <TenantBar 
                            companiesList = {companiesList}
                            branchesList = {branchesList}
                            companySelected={companySelected} 
                            branchSelected={branchSelected} />
                    </div>
                    <LogoEchoSystem name="مستودعات" />
                    <UserBar
                        tenantUsername = {tenantUsername}
                        tenant = {tenant}
                    />
                </div> 
            </div>
            </div> */}
                 <div className=' w-[100%]  flex justify-between items-center bg-[#251658]  sticky top-0 z-50 text-white  '>
            <div className="px-3 py-1 m-auto  w-full  px-1  flex justify-between items-center ">
                <div className='flex flex-col md:flex-row  w-full  justify-between items-center '>
                    <div className='flex items-center justify-between w-full '>
                        {/* <MenuButton openMenu = {openMenu}  setOpenMenu = {setOpenMenu} /> */}
                        <TenantBar 
                            companiesList = {companiesList}
                            branchesList = {branchesList}
                            companySelected={companySelected} 
                            branchSelected={branchSelected} />
                    </div>
                    <LogoEchoSystem name="مستودعات" />
                    <UserBar
                        tenantUsername = {tenantUsername}
                        tenantImage = {tenantImage}
                        tenant = {tenant}
                    />
                </div> 
            </div>
            </div>
        </>
    )
}

export default  HeaderNavBar 